// tslint:disable
export default class Search {
  // Nice simple fuzzy search from https://stackoverflow.com/a/15252131
  // Returns true if the searchTerm is found anywhere in searchString
  public static fuzzySearch(searchString: string | null | undefined, searchTerm: string): boolean {
    if (searchString === null || searchString === undefined || searchTerm === null || searchTerm === undefined) {
      return false;
    }

    let startMinusOne = -1;
    searchTerm = searchTerm.toLowerCase().trim();
    searchString = searchString.toLowerCase();

    for (let i = 0; i < searchTerm.length; i++) {
      // This does the fuzzy searching
      if (!~(startMinusOne = searchString.indexOf(searchTerm[i], startMinusOne + 1))) {
        return false;
      }
    }

    return true;
  }
}
